var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "#1F72CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18111 8.5L2 15.7467H5.80824L6.28035 14.5913H7.35949L7.8316 15.7467H12.0234V14.8649L12.3969 15.7467H14.5652L14.9387 14.8462V15.7467H23.6566L24.7166 14.6213L25.7092 15.7467L30.1868 15.7561L26.9957 12.1436L30.1868 8.5H25.7786L24.7467 9.60463L23.7854 8.5H14.3016L13.4872 10.3704L12.6537 8.5H8.85343V9.35186L8.43068 8.5H5.18111ZM5.91799 9.52905H7.7743L9.88433 14.4431V9.52905H11.9178L13.5476 13.0524L15.0496 9.52905H17.073V14.7291H15.8418L15.8317 10.6544L14.0368 14.7291H12.9355L11.1305 10.6544V14.7291H8.59773L8.11756 13.5633H5.52338L5.04421 14.728H3.68717L5.91799 9.52905ZM23.2055 9.52905H18.1994V14.726H23.128L24.7166 13.0036L26.2477 14.726H27.8484L25.5219 12.1426L27.8484 9.52905H26.3172L24.7367 11.2316L23.2055 9.52905ZM6.82101 10.4089L5.96634 12.4856H7.6747L6.82101 10.4089ZM19.4356 11.555V10.6057V10.6048H22.5593L23.9223 12.1229L22.4989 13.6493H19.4356V12.613H22.1667V11.555H19.4356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/AmericanExpress.a44c26bdbb1d350dfd9be1322289ded5.svg";
export { ForwardRef as ReactComponent };